/**
 * Compatibility layer for the deprecated tradeTypeMap.json
 * 
 * This module provides the same data structure as the old JSON file
 * but sources data from the canonical tradeCategories.ts module.
 * 
 * IMPORTANT: This is a transitional module and should be considered deprecated.
 * New code should use tradeCategories.ts directly.
 */

import { TRADE_CATEGORIES } from '../tradeCategories';

/**
 * Recreates the structure of the old tradeTypeMap.json file
 */
export const tradeTypeMap = {
  /**
   * Metadata about this compatibility layer
   */
  _deprecated: "This is a compatibility layer for the deprecated tradeTypeMap.json. Please use tradeCategories.ts directly for new code.",
  
  /**
   * Mapping of trade types to keywords
   */
  trade_types: TRADE_CATEGORIES.reduce<Record<string, string[]>>((acc, category) => {
    acc[category.id] = category.keywords;
    return acc;
  }, {})
};

export default tradeTypeMap;